import { adminConstants } from '../constant/admin-constant';
// import { objectsConstants as OC } from '../constant/objects-constant';

const initialState = {
	loadingSettings: false,
	countries: [
		{
			label: 'Pakistan',
			value: 7
		},
		{
			label: 'China',
			value: 2
		}
	],
	primaryStates: [],
	secondaryStates: [],
	states: [],
	programType: [],
	agency_type_id: [],
	salesRep: [],
	invoice_style_id: [],
	statesType: '',
	addtionalServcies: {},
	showLoader: true,
	/*userPreferences:OC.USERPREFERENCES, additionalFilters:OC.ADITIONALFILTERS, advanceSearch:OC.ADVANCESEARCH*/
};

export function settingsReducer(state = initialState, action) {

	switch (action.type) {

		case adminConstants.GET_AGENCY_TYPE_REQUEST:
			return { ...state, loadingSettings: true };
		case adminConstants.GET_AGENCY_TYPE_SUCCESS:
			return { ...state, loadingSettings: false, agency_type_id: action.payload.agencyTypes };
		case adminConstants.GET_AGENCY_TYPE_FAILURE:
			return { ...state, loadingSettings: false, error: action.payload };

		case adminConstants.GET_COUNTRIES_REQUEST:
			return { ...state, loadingSettings: true };
		case adminConstants.GET_COUNTRIES_SUCCESS:
			return { ...state, loadingSettings: false, countries: action.payload.countries };
		case adminConstants.GET_COUNTRIES_FAILURE:
			return { ...state, loadingSettings: false, error: action.payload };

		case adminConstants.GET_PRIMARY_STATES_REQUEST:
			return { ...state, loadingSettings: true };
		case adminConstants.GET_PRIMARY_STATES_SUCCESS:
			return { ...state, loadingSettings: false, primaryStates: action.payload.states };
		case adminConstants.GET_PRIMARY_STATES_FAILURE:
			return { ...state, loadingSettings: false, error: action.payload };

		case adminConstants.GET_SECONDARY_STATES_REQUEST:
			return { ...state, loadingSettings: true };
		case adminConstants.GET_SECONDARY_STATES_SUCCESS:
			return { ...state, loadingSettings: false, secondaryStates: action.payload.states };
		case adminConstants.GET_SECONDARY_STATES_FAILURE:
			return { ...state, loadingSettings: false, error: action.payload };

		case adminConstants.GET_STATES_REQUEST:
			return { ...state, loadingSettings: true };
		case adminConstants.GET_STATES_SUCCESS:
			return { ...state, loadingSettings: false, states: action.payload.data.states, statesType: action.payload.data.type };
		case adminConstants.GET_STATES_FAILURE:
			return { ...state, loadingSettings: false, error: action.payload };

		case adminConstants.GET_SALES_REP_REQUEST:
			return { ...state, loadingSettings: true };
		case adminConstants.GET_SALES_REP_SUCCESS:
			return { ...state, loadingSettings: false, salesRep: action.payload.user };
		case adminConstants.GET_SALES_REP_FAILURE:
			return { ...state, loadingSettings: false, error: action.payload };

		case adminConstants.GET_AGENCY_SALES_REP_REQUEST:
			return { ...state, loadingSettings: true };
		case adminConstants.GET_AGENCY_SALES_REP_SUCCESS:
			return { ...state, loadingSettings: false, agencySalesRep: action.payload.user };
		case adminConstants.GET_AGENCY_SALES_REP_FAILURE:
			return { ...state, loadingSettings: false, error: action.payload };

		case adminConstants.GET_PROGRAM_TYPE_REQUEST:
			return { ...state, loadingSettings: true };
		case adminConstants.GET_PROGRAM_TYPE_SUCCESS:
			return { ...state, loadingSettings: false, programType: action.payload.programTypes };
		case adminConstants.GET_PROGRAM_TYPE_FAILURE:
			return { ...state, loadingSettings: false, error: action.payload };


		case adminConstants.GET_MAIN_PROGRAM_TYPE_REQUEST:
			return { ...state, loadingSettings: true };
		case adminConstants.GET_MAIN_PROGRAM_TYPE_SUCCESS:
			return { ...state, loadingSettings: false, mainProgramType: action.payload.mainProgramType };
		case adminConstants.GET_MAIN_PROGRAM_TYPE_FAILURE:
			return { ...state, loadingSettings: false, error: action.payload };

		case adminConstants.GET_PROGRAM_ITEM_REQUEST:
			return { ...state, loadingSettings: true };
		case adminConstants.GET_PROGRAM_ITEM_SUCCESS:
			return { ...state, loadingSettings: false, items: action.payload.items };
		case adminConstants.GET_PROGRAM_ITEM_FAILURE:
			return { ...state, loadingSettings: false, error: action.payload };

		case adminConstants.GET_INVOICING_REQUEST:
			return { ...state, loadingSettings: true };
		case adminConstants.GET_INVOICING_SUCCESS:
			return { ...state, loadingSettings: false, invoice_style_id: action.payload.invoiceStyles };
		case adminConstants.GET_INVOICING_FAILURE:
			return { ...state, loadingSettings: false, error: action.payload };

		case adminConstants.GET_SETTING_VALUE_REQUEST:
			return { ...state, loadingSettings: true };
		case adminConstants.GET_SETTING_VALUE_SUCCESS:
			return { ...state, loadingSettings: false, settings: action.payload.settings };
		case adminConstants.GET_SETTING_VALUE_FAILURE:
			return { ...state, loadingSettings: false, error: action.payload };

		case adminConstants.GET_USER_PREFERENCE_REQUEST:
			return { ...state, loadingSettings: true };
		case adminConstants.GET_USER_PREFERENCE_SUCCESS:
			return { ...state, loadingSettings: false, userPreferences: action.payload.userPreferences.preferences };
		case adminConstants.GET_USER_PREFERENCE_FAILURE:
			return { ...state, loadingSettings: false, error: action.payload };

		case adminConstants.GET_SETTING_BY_MODEL_ID_REQUEST:
			return { ...state, loadingSettings: true };
		case adminConstants.GET_SETTING_BY_MODEL_ID_SUCCESS:
			return { ...state, loadingSettings: false, settings: action.payload.settings };
		case adminConstants.GET_SETTING_BY_MODEL_ID_FAILURE:
			return { ...state, loadingSettings: false, error: action.payload };

		case adminConstants.STORE_SETTINGS_DATA_REQUEST:
			return { ...state, loadingSettings: true };
		case adminConstants.STORE_SETTINGS_DATA_SUCCESS:
			return { ...state, loadingSettings: false, storedSetting: action.payload.storedSetting };
		case adminConstants.STORE_SETTINGS_DATA_FAILURE:
			return { ...state, loadingSettings: false, error: action.payload };

		case adminConstants.UPDATE_SETTINGS_DATA_REQUEST:
			return { ...state, loadingSettings: true };
		case adminConstants.UPDATE_SETTINGS_DATA_SUCCESS:
			return { ...state, loadingSettings: false, updatedSetting: action.payload.settings };
		case adminConstants.UPDATE_SETTINGS_DATA_FAILURE:
			return { ...state, loadingSettings: false, error: action.payload };
		case adminConstants.CLEAR_SETTINGS_REQUEST:
			return { ...initialState };
		case adminConstants.GET_ADDITIONAL_SERVICES_SUCCESS:
			return {
				...state,
				addtionalServcies: action.payload.data
			}
		case adminConstants.GET_SINGLE_ADDITIONAL_ITEM_SUCCESS:
			return {
				...state,
				singleAdditionalService: action.payload.data
			}
		case adminConstants.GET_SINGLE_ADDITIONAL_ITEM_FAILURE:
			return {
				...state,
				error: action.payload
			}
		case adminConstants.UPDATE_SINGLE_ADDITIONAL_ITEM_SUCCESS:
			const data = [...state.addtionalServcies.data];
			data[action.index] = action.payload.data;
			return {
				...state,
				addtionalServcies: {
					...state.addtionalServcies,
					data: data
				}
			}
		case adminConstants.UPDATE_SINGLE_ADDITIONAL_ITEM_FAILURE:
			return {
				...state,
				error: action.payload
			}
		case adminConstants.DELETE_SINGLE_ADDITIONAL_ITEM_SUCCESS:
			return {
				...state,
				addtionalServcies: {
					...state.addtionalServcies,
					data: action.payload
				}
			}
		case adminConstants.DELETE_SINGLE_ADDITIONAL_ITEM_FAILURE:
			return {
				...state,
				error: action.payload
			}
		case adminConstants.SET_GLOBAL_LOADER:
			return { ...state, showLoader: action.payload };

		default:
			return { ...state };
	}
}


// WEBPACK FOOTER //
// ./src/redux/reducers/SettingsReducer.jsx